import { ReactNode } from 'react';
import { LogoutIcon } from '@heroicons/react/solid';

import { Permissionable } from '@imaging/types';
import { EntityHistory } from '../entity-history';
import { DatabaseUser, HistoryItem } from '@/core/types';

export default class LogoutHistory extends EntityHistory {
  constructor(history: HistoryItem, user: DatabaseUser, permissionables: Permissionable[]) {
    super(history, user, permissionables);
    this.action = 'logged out';
  }

  displayText(): ReactNode {
    return (
      <>
        <b>{this.userName}</b> {this.action}
      </>
    );
  }

  detailText(): string {
    if (this.history.attributes?.migrated) {
      return this.history.attributes?.migrated.description;
    } else {
      return `${this.userFullName()} ${this.action}`;
    }
  }

  detailIcon(): ReactNode {
    return <LogoutIcon className="h-5 fill-support-error" />;
  }
}
